<template>
  <div class="lambhead content-container BTN-wrap ">
    <a-row>
      <a-col
        :span="4"
        @click="toHome"
      >
        <img
          :src="imgSrc"
          class="lambda-logo"
          alt="Lambda"
        >
      </a-col>
      <a-col :span="16">
        <a
          class="launchBtn"
          href="https://portal.lambda.im/"
          target="_blank"
        >
          <div>
            Get LAMBDA
          </div>
        </a>
        <div class="fr menu-container">
          <a-menu
            v-model="current"
            mode="horizontal"
          >

            <a-menu-item key="aridrop">
              <router-link to="/airdrop">
                Airdrop
              </router-link>
            </a-menu-item>
              
            <!-- <a-menu-item key="storage">

              <a-dropdown placement="bottomCenter">
                <a class="ant-dropdown-link">
                  {{ $t("head.storage") }}
                  <a-icon type="down" />
                </a>
                <a-menu
                  slot="overlay"
                >
                  <a-menu-item key="evm">
                    <a href="https://storage.lambda.im" target="_blank">
                      {{ $t("head.dataexplorer") }}
                    </a>
                  </a-menu-item>
                  <a-menu-item key="validators">
                    <a href="https://docs.lambda.im/validators/overview.html" target="_blank">
                      {{ $t("head.validators") }}
                    </a>
                  </a-menu-item>
                  <a-menu-item key="providers">
                    <a href="https://docs.lambda.im/storage/overview.html" target="_blank">
                      {{ $t("head.providers") }}
                    </a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>

            </a-menu-item> -->

            <a-menu-item key="evm">
              <a href="https://scan.lambda.im" target="_blank">
                {{ $t("head.explorer") }}
              </a>
            </a-menu-item>

            <a-menu-item key="docscenter2">
              <a
                href="https://docs.lambda.im"
                target="_blank"
              >
                {{ $t("head.docs") }}
              </a>
            </a-menu-item>

          </a-menu>
        </div>
        <div
          class="fr mobile-menu-container"
          @click="showDrawer"
        >
          <div class="menu-button-wrapper">
            <div :class="getBtncolor" />
            <div :class="getBtncolor" />
            <div :class="getBtncolor" />
          </div>
          <a-drawer
            :z-index="getIndex"
            :closable="true"
            :visible="visible"
            placement="right"
            @close="onClose"
          >
            <div
              slot="title"
              class="title-wrapper"
            >
              <img
                style="width: 115px"
                src="../assets/home/1.svg"
                alt="Lambda"
              >
            </div>

          
            <a-menu mode="inline">

             
             
              <!-- <a-sub-menu key="storage">
                <span slot="title">
                  <span>{{ $t("head.storage") }}</span>
                </span>
                <a-menu>
                  <a-menu-item key="evm">
                    <a href="https://storage.lambda.im" target="_blank">
                      {{ $t("head.dataexplorer") }}
                    </a>
                  </a-menu-item>
                  <a-menu-item key="validators">
                    <a href="https://docs.lambda.im/validators/overview.html" target="_blank">
                      {{ $t("head.validators") }}
                    </a>
                  </a-menu-item>
                  <a-menu-item key="providers">
                    <a href="https://docs.lambda.im/storage/overview.html" target="_blank">
                      {{ $t("head.providers") }}
                    </a>
                  </a-menu-item>
                 
                </a-menu>
              </a-sub-menu> -->

              <a-menu-item key="evm">
                <a href="https://scan.lambda.im" target="_blank">
                  {{ $t("head.explorer") }}
                </a>
              </a-menu-item>


              <a-menu-item key="docscenter">
                <a
                  href="https://docs.lambda.im"
                  target="_blank"
                >
                  {{ $t("head.docs") }}
                </a>
              </a-menu-item>

              <a-menu-item key="docscenter">
                <a
                  href="https://portal.lambda.im/"
                  target="_blank"
                >
                  Get LAMBDA
                </a>
              </a-menu-item>
            </a-menu>
          </a-drawer>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import indexImgSrc from "../assets/home/2.svg";
import otherImgSrc from "../assets/home/1.svg";
import jscookie from "js-cookie";
export default {
  data () {
    return {
      visible: false,
      change: false,
      current: ["home"],
      lang: "English"
    };
  },
  computed: {
    getLink () {
      // console.log(this.change);
      if (!this.change) {
        return "whiteLink normalFont";
      }
      if (this.change == true) {
        return "blackLink normalFont";
      }
      return "whiteLink normalFont";
    },
    getBtncolor () {
      if (!this.change) {
        return "menu-item-btn white";
      }
      if (this.change == true) {
        return "menu-item-btn blue";
      }
      return "menu-item-btn blue";
    },
    getIndex () {
      return parseInt("9999");
    },
    imgSrc () {
      if (!this.change) {
        return indexImgSrc;
      } else {
        return otherImgSrc;
      }
    }
  },
  watch: {
    $route (to) {
      this.change = to.meta.changeNav;
      if (to.name == "news") {
        this.current[0] = "sub2";
      } else {
        this.current[0] = to.name;
      }

      this.visible = false;
    }
  },
  methods: {
    showDrawer () {
      this.visible = true;
    },
    onClose () {
      this.visible = false;
    },
    toHome () {
      this.$router.push("/");
    },
    getLang () {
      this.$i18n.locale = 'en';
    }
  },
  mounted () {
    this.getLang();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.menu-container {
  .menu-content {
    color: #000;
  }
}
.lambda-logo {
  width: 112px;
  height: 40px;
  cursor: pointer;
}
.lambhead {
  position: relative;
  .launchBtn {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -180px;
    top: 0;
    height: 100%;

    div {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 36px;
      padding: 5px 20px;
      border-radius: 6px;
      background: #9155fd;
      color: #fff;
    }
    :hover {
      background: #8344f8;
    }
  }

  .menu-button-wrapper {
    margin-top: 24px;
    .menu-item-btn {
      width: 20px;
      margin-bottom: 5px;
      height: 2px;
      // background-color: #fff;
      border-radius: 5px;
    }
  }
}

.blue {
  background-color: #3f4ae1;
}

.white {
  background-color: #fff;
}

@media (min-width: 320px) and (max-width: 1100px) {
  .lambhead {
    .mobile-menu-container {
      display: block;
    }
    .launchBtn {
      display: none;
    }
    .menu-container {
      display: none;
    }
  }
}
@media (min-width: 1101px) {
  .lambhead {
    .mobile-menu-container {
      display: none;
    }
    .menu-container {
      display: block;
    }
  }
}
</style>
